import brandMark from '../assets/virei-noiva-mark.svg';

const SIZE_MAP = {
  sm: {
    icon: 'h-6 w-6',
    title: 'text-xl',
    subtitle: 'text-[0.5rem] tracking-[0.26em]'
  },
  md: {
    icon: 'h-8 w-8',
    title: 'text-2xl',
    subtitle: 'text-[0.55rem] tracking-[0.3em]'
  },
  lg: {
    icon: 'h-9 w-9',
    title: 'text-[2.1rem]',
    subtitle: 'text-[0.63rem] tracking-[0.42em]'
  }
};

export default function BrandLogo({
  size = 'md',
  withText = true,
  showTagline,
  className = '',
  iconClassName = '',
  textClassName = '',
  taglineClassName = '',
  text = 'Virei Noiva',
  tagline = 'PREMIUM WEDDING EXPERIENCE'
}) {
  const resolvedSize = SIZE_MAP[size] || SIZE_MAP.md;
  const shouldShowTagline = typeof showTagline === 'boolean' ? showTagline : size === 'lg';

  if (!withText) {
    return (
      <span className={`inline-flex items-center ${className}`}>
        <img
          src={brandMark}
          alt="Virei Noiva"
          className={`${resolvedSize.icon} shrink-0 object-contain ${iconClassName}`}
        />
      </span>
    );
  }

  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      <img
        src={brandMark}
        alt="Virei Noiva"
        className={`${resolvedSize.icon} shrink-0 object-contain ${iconClassName}`}
      />
      <span className="inline-flex flex-col leading-none">
        <span
          className={`${resolvedSize.title} text-[#2E2928] ${textClassName}`}
          style={{ fontFamily: 'Playfair Display, serif' }}
        >
          {text}
        </span>
        {shouldShowTagline ? (
          <span
            className={`mt-1 uppercase text-[#9D958C] ${resolvedSize.subtitle} ${taglineClassName}`}
          >
            {tagline}
          </span>
        ) : null}
      </span>
    </span>
  );
}
